/**
 * biz-password-input — Reusable password + confirm component
 *
 * Bindings:
 *   onPasswordChange  {function}  callback — llamado con {value, valid} en cada cambio.
 *                                 value: string del password cuando es válido, '' si no.
 *                                 valid: true cuando vacío (sin cambio) O válido+matching.
 *   isDisabled        {boolean}   one-way — deshabilita inputs y botones.
 *
 * IMPORTANTE: NO usar ng-disabled en el tag del componente — colisiona con la
 * directiva built-in. Usar is-disabled="expr" en su lugar.
 *
 * Uso:
 *   <biz-password-input
 *       on-password-change="onPasswordChange(value, valid)"
 *       is-disabled="isLoading">
 *   </biz-password-input>
 *
 * Diseño interno:
 *   _pwd / _confirm son las únicas variables ligadas a los inputs via ng-model.
 *   Nunca se reescriben desde validate(), garantizando que el cursor nunca
 *   se resetea. El padre recibe los datos exclusivamente via el callback —
 *   sin two-way binding que pueda interferir con el digest cycle.
 */
angular.module('bizmetryApp').component('bizPasswordInput', {

    templateUrl: 'common/components/biz-password-input/BizPasswordInput.html',

    bindings: {
        onPasswordChange: '&',
        isDisabled: '<'
    },

    controller: ['$mdToast', '$timeout', function ($mdToast, $timeout) {
        var ctrl = this;

        // ── Estado interno — ÚNICA fuente de verdad para los inputs ───────────────
        ctrl._pwd = '';
        ctrl._confirm = '';

        ctrl.showPassword = false;
        ctrl.showConfirm = false;
        ctrl.passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[#@_!$])[A-Za-z\d#@_!$]{8,}$/;
        ctrl.validation = { checked: false, match: false };

        // ── Lifecycle ─────────────────────────────────────────────────────────────
        ctrl.$onInit = function () {
            ctrl.isDisabled = ctrl.isDisabled || false;
            // Notificar estado inicial: vacío = válido (sin cambio)
            _notify('', true);
        };

        // ── Validación + notificación al padre vía callback ───────────────────────
        ctrl.validate = function () {
            var pwd = ctrl._pwd || '';
            var confirm = ctrl._confirm || '';
            var isEmpty = !pwd && !confirm;

            if (isEmpty) {
                ctrl.validation.checked = false;
                ctrl.validation.match = false;
                _notify('', true);
                return;
            }

            ctrl.validation.checked = !!(pwd && confirm);
            ctrl.validation.match = pwd === confirm && pwd.length > 0;

            var patternOk = ctrl.passwordPattern.test(pwd);
            var isValid = ctrl.validation.match && patternOk;

            _notify(isValid ? pwd : '', isValid);
        };

        // ── Notifica al padre — nunca modifica _pwd/_confirm ─────────────────────
        function _notify(value, valid) {
            $timeout(function () {
                ctrl.onPasswordChange({ value: value, valid: valid });
            }, 0);
        }

        // ── Strength meter ────────────────────────────────────────────────────────
        ctrl.getStrength = function () {
            var p = ctrl._pwd || '';
            if (!p) return 0;
            var s = 0;
            if (p.length >= 8) s += 20;
            if (p.length >= 12) s += 10;
            if (p.length >= 16) s += 10;
            if (/[a-z]/.test(p)) s += 10;
            if (/[A-Z]/.test(p)) s += 15;
            if (/\d/.test(p)) s += 15;
            if (/[#@_!$]/.test(p)) s += 20;
            return Math.min(100, s);
        };

        ctrl.getStrengthLevel = function () {
            var s = ctrl.getStrength();
            if (s < 40) return 'weak';
            if (s < 60) return 'fair';
            if (s < 85) return 'good';
            return 'strong';
        };

        ctrl.getStrengthLabel = function () {
            return { weak: 'Weak', fair: 'Fair', good: 'Good', strong: 'Strong' }[ctrl.getStrengthLevel()];
        };

        // ── Auto-generate ─────────────────────────────────────────────────────────
        ctrl.autoGenerate = function () {
            var upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var lower = 'abcdefghijklmnopqrstuvwxyz';
            var numbers = '0123456789';
            var special = '#@_!$';
            var all = upper + lower + numbers + special;

            var pwd = upper[_rand(upper.length)]
                + lower[_rand(lower.length)]
                + numbers[_rand(numbers.length)]
                + special[_rand(special.length)];

            for (var i = pwd.length; i < 12; i++) pwd += all[_rand(all.length)];
            pwd = pwd.split('').sort(function () { return Math.random() - 0.5; }).join('');

            ctrl._pwd = pwd;
            ctrl._confirm = pwd;
            ctrl.validate();

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Secure password generated!')
                    .position('top right')
                    .hideDelay(2000)
            );
        };

        function _rand(max) { return Math.floor(Math.random() * max); }

        // ── Reset sub-form cuando ambos campos quedan vacíos ──────────────────────
        ctrl._resetFormIfEmpty = function () {
            if (ctrl._pwd || ctrl._confirm) return;
            if (!ctrl.passwordForm) return;

            $timeout(function () {
                ['newPassword', 'confirmPassword'].forEach(function (name) {
                    var f = ctrl.passwordForm[name];
                    if (f) { f.$setPristine(); f.$setUntouched(); }
                });
                ctrl.validation.checked = false;
                ctrl.validation.match = false;
                _notify('', true);
            }, 0);
        };

    }]
});